import { useCompanyStore } from "web-apps/company/stores/companyStore/companyStore";

interface UseCompanySubscriptionParams {
  readonly companyId: number | null | undefined;
  readonly isEnabled: boolean;
}

/** Returns the subscription already loaded for the active company. */
export const useCompanySubscription = (
  params: UseCompanySubscriptionParams,
): string | undefined => {
  const [companyState] = useCompanyStore();
  if (!params.isEnabled || companyState.company?.id !== params.companyId) {
    return undefined;
  }

  return companyState.subscription.info?.membershipDisplayName;
};
